// @packages
import { makeStyles } from '@rneui/themed';

export default makeStyles((theme) => ({
  container: {
    alignItems: 'center',
    backgroundColor: theme.colors.background,
    flex: 1,
    justifyContent: 'center',
    padding: 30
  }
}));
